export default "__VITE_ASSET__CqmLVO$l__"